import { Erp, PointOfSale } from 'common/types';

export const isZettiFormat = (pointOfSale: PointOfSale) => pointOfSale?.erp_id === Erp.ZETTI;

export const isGestorERPFormat = (pointOfSale: PointOfSale) => pointOfSale?.erp_id === Erp.GESTOR;
